import {
    Bundle,
    ensureBundleById,
    ensureFullOpenTransfersForTruck,
    ensureFullScheduledTransfersAt,
    ensureFullScheduledTransfersAwaitingTruck,
    ensureFullTransfersAtVenue,
    ensureFullTriplegsInboundTo,
    ensureLastTriplegForTruck,
    ensureTrucksDockedAt,
    KingBasura,
    PickupOrDropoff,
    ScheduledTransfer,
    Transfer,
    Tripleg,
    TruckStub,
    useFullOpenTransfersForTruck,
    useFullScheduledTransfersAt,
    useFullScheduledTransfersAwaitingTruck,
    useFullTransfersAtVenue,
    useFullTriplegsInboundTo,
    useFullUnadmittedTriplegsInto,
    useLastTriplegForTruck,
    useTrucksDockedAt,
    watchBundleByIdTqo
} from "../rpc/webrpc-client.gen.ts";
import {z} from "zod/v4";
import {QueryClient, queryOptions, skipToken, useQueries, useQueryClient} from "@tanstack/react-query";
import {InfallibleUseResult, pendingUseResult, successUseResult} from "../util/hookutil.tsx";
import {ensureLastSceneForTruck, TruckScene, TruckTimelineRelay, useLastSceneForTruck} from "../truck/timeline.tsx";
import {cleanse, NADA, objectFromEntries} from "../util/arutil.tsx";
import {Fragment, useEffect} from "react";
import {mergeUseQueriesWithInfill} from "../tq/mergeUseQueriesWithInfill.tsx";
import {InfallibleUseQueryResult} from "../util/useInfallibleQuery.tsx";
import {useRefreshableInfallibleQuery} from "../util/tqrefresh.tsx";
import {VenueOverviewTruckStatusCode} from "../venue/venueOverviewTruckStatusCode.tsx";
import {useMothership} from "../tq/tqx.tsx";

// import {useSelf} from "../useSelf.ts";
// import {useMutation, useQuery} from "@tanstack/react-query";
// import {LimitedUseQueryOptions, TQDEADBEEF, useRefreshableQuery} from "../tqutil.ts";
// import {
//     admitVerb,
//     Tripleg, watchAdmittersOnDutyForVenueTqo,
//     watchOpenBundleTransfersForTruckTqo
// } from "../rpc/webrpc-client.gen.ts";
// import {GLOBAL_MOTHERSHIP} from "../main.tsx";
// import {arrivalRefreshSet, bundleExpandedTransfersTqxo, startBundleOffloadingTqmo} from "../tqx.ts";
// import {useCallback} from "react";
// import {useMountedTruck} from "../driver/mountedTruck.ts";
// import {isEmpty} from "lodash";
//
// export type UseAdmitterArgs = LimitedUseQueryOptions<{
//     tripleg: Tripleg | undefined;
// }>;
//
// export interface UseAdmitterResult {
//     admit: () => Promise<unknown>;
//     isSuccess: boolean;
// }
//
// you might not actually be an authorized admitter. if nobody is on duty,
// non-admitters can call this and admit themselves

// export function useAdmitter({tripleg, enabled, ...rest}: UseAdmitterArgs): UseAdmitterResult {
//     if (enabled === undefined) {
//         enabled = true;
//     }
//     const {data: self} = useSelf();
//     const authorizedAdmitVenueId = self?.admitterFor?.id ?? TQDEADBEEF;
//     const canDrive = self?.canDrive;
//     const {data: mountedTruckData}
//         = useMountedTruck({enabled: canDrive});
//     const mountedTruckId = mountedTruckData?.truck?.id ?? TQDEADBEEF;
//     const isMyTripleg = tripleg?.truck.id === mountedTruckId && mountedTruckId !== TQDEADBEEF;
//     const destinationVenueId = tripleg?.destination.id ?? TQDEADBEEF;
//     const {data: onDutyAdmittersData, isSuccess: isOnDutyAdmittersSuccess}
//     = useQuery({
//         ...watchAdmittersOnDutyForVenueTqo({venueId: destinationVenueId}),
//         enabled: destinationVenueId !== TQDEADBEEF,
//     })
//     const isVenueAutoAdmit = isOnDutyAdmittersSuccess && isEmpty(onDutyAdmittersData.admitters);
//     const canAdmit =
//         (authorizedAdmitVenueId !== TQDEADBEEF && authorizedAdmitVenueId === destinationVenueId)
//         || (isMyTripleg && !!isVenueAutoAdmit);
//
//     if (!canAdmit) {
//         enabled = false;
//     }
//
//     if (enabled && !tripleg) {
//         throw new Error("if useAdmitter is enabled, tripleg must be legit");
//     }
//
//     const {mutateAsync: performAdmit} = useMutation({
//         mutationKey: [admitVerb],
//         mutationFn: ({tripleg}: { tripleg: Tripleg }) =>
//             GLOBAL_MOTHERSHIP.admit({triplegId: tripleg.id}),
//         onSuccess: (_, {tripleg}) =>
//             arrivalRefreshSet({truckId: tripleg.truck.id}).invalidate(),
//     });
//
//     const {data: allTruckTransfersData, isSuccess: isTransfersSuccess}
//         = useRefreshableQuery({
//         ...watchOpenBundleTransfersForTruckTqo({truckId: tripleg?.truck.id ?? TQDEADBEEF}),
//         enabled: enabled || canAdmit,
//         ...rest,
//     });
//     const {data: allTruckBundledTransfers, isSuccess: isBundledTransfersSuccess}
//         = useRefreshableQuery({
//         ...bundleExpandedTransfersTqxo({transfers: allTruckTransfersData?.transfers ?? []}),
//         enabled: enabled || (canAdmit && isTransfersSuccess),
//     });
//     const localTransfers = (allTruckBundledTransfers ?? []).filter(
//         transfer => transfer.bundle?.destination?.id === destinationVenueId);
//     const {mutateAsync: performStartOffloading}
//         = useMutation(startBundleOffloadingTqmo);
//
//     const canPerform = canAdmit && isTransfersSuccess && isBundledTransfersSuccess && !!tripleg;
//
//     const perform = useCallback(() => {
//         if (canPerform) {
//             return performAdmit({tripleg})
//                 .then(() => Promise.all(
//                     localTransfers.map(xtransfer =>
//                         performStartOffloading(
//                             {
//                                 bundleId: xtransfer.transfer.bundleId,
//                                 venueId: destinationVenueId,
//                             }))
//                 ));
//         } else {
//             return Promise.reject(new Error("cannot perform admittance"));
//         }
//     }, [canPerform, destinationVenueId,
//         localTransfers, performAdmit, performStartOffloading, tripleg]);
//
//     return {admit: perform, isSuccess: canPerform};
// }

export const admitterTruckStubsVerb = "AdmitterTruckStubs";

export function admitterTruckStubsTqk(args?: { venueId: string }) {
    return args ? [admitterTruckStubsVerb, args] as const : [admitterTruckStubsVerb] as const;
}

export const AdmitterTruckStubs = z.object({
    truckStubs: TruckStub.array(),
});
export type AdmitterTruckStubs = z.infer<typeof AdmitterTruckStubs>;

function extractUniqueTruckStubs(
    {triplegs, transfers, dockedTrucks, schedule}: {
        triplegs: (Tripleg | undefined)[], transfers: (Transfer | undefined)[],
        dockedTrucks: (TruckStub | undefined)[], schedule: (ScheduledTransfer | undefined)[]
    }): TruckStub[] {
    const stubsById = new Map<string, TruckStub>();

    for (const tripleg of triplegs) {
        if (tripleg?.truck.id) {
            stubsById.set(tripleg.truck.id, tripleg.truck);
        }
    }
    for (const transfer of transfers) {
        if (transfer) {
            stubsById.set(transfer.truck.id, transfer.truck);
        }
    }
    for (const dt of dockedTrucks) {
        if (dt) {
            stubsById.set(dt.id, dt);
        }
    }
    for (const sxfer of schedule) {
        if (sxfer?.truck) {
            stubsById.set(sxfer.truck.id, sxfer.truck);
        }
    }

    return Array.from(stubsById.values());
}

function ensureAdmitterTruckStubs(args: {
    tqc: QueryClient,
    mama: KingBasura,
    args: { venueId: string }
}): Promise<AdmitterTruckStubs> {
    return Promise.all([
        ensureFullTriplegsInboundTo(args).then(rpcs => rpcs.map(rpc => rpc.tripleg)),
        ensureFullTransfersAtVenue(args).then(rpcs => rpcs.map(rpc => rpc.transfer)),
        ensureTrucksDockedAt(args).then(rpc => rpc.trucks),
        ensureFullScheduledTransfersAt(args).then(rpcs => rpcs.map(rpc => rpc.scheduledTransfer)),
    ]).then(([inboundTriplegs, transfers, dockedTrucks, schedule]) => {
        const uniqueStubs = extractUniqueTruckStubs({
            triplegs: inboundTriplegs, transfers, dockedTrucks, schedule,
        })

        return {truckStubs: Array.from(uniqueStubs)};
    });
}

export function admitterTruckStubsTqo(args?: {
    tqc: QueryClient,
    mama: KingBasura,
    args: { venueId: string }
}) {
    return queryOptions({
        // eslint-disable-next-line @tanstack/query/exhaustive-deps
        queryKey: admitterTruckStubsTqk(args ? args.args : undefined),
        queryFn: args ? () => ensureAdmitterTruckStubs(args) : skipToken,
    });
}

export function useAdmitterTruckStubs(args: { venueId: string }): InfallibleUseResult<TruckStub[]> {
    const {data: unadmittedTriplegs, isPending: isUnadmittedTriplegsPending} = useFullUnadmittedTriplegsInto(args);
    const {data: inboundTriplegs, isPending: isInboundTriplegsPending} = useFullTriplegsInboundTo(args);
    const {data: transfers, isPending: isTransfersPending} = useFullTransfersAtVenue(args);
    const {data: dockedTrucks, isPending: isDockedTrucksPending} = useTrucksDockedAt(args);
    const {data: schedule, isPending: isSchedulePending} = useFullScheduledTransfersAt(args);

    if (isUnadmittedTriplegsPending || isInboundTriplegsPending
        || isDockedTrucksPending || isTransfersPending || isSchedulePending) {
        return pendingUseResult;
    }

    const uniqueStubs = extractUniqueTruckStubs({
        triplegs: [...unadmittedTriplegs, ...inboundTriplegs],
        transfers, dockedTrucks, schedule
    });

    return successUseResult(uniqueStubs);
}

const TruckBundleAction = z.object({
    direction: PickupOrDropoff,
    bundle: Bundle,
    scheduled: z.optional(ScheduledTransfer),
    activeTransfer: z.optional(Transfer),
});

type TruckBundleAction = z.infer<typeof TruckBundleAction>;

export const GateTruck = z.object({
    stub: TruckStub,
    statusCode: VenueOverviewTruckStatusCode,
    lastScene: z.nullable(TruckScene),
    lastTripleg: z.nullable(Tripleg),
    activeTransfersHere: TruckBundleAction.array(),
    possibleTransfersHere: TruckBundleAction.array(),
});
export type GateTruck = z.infer<typeof GateTruck>;

function figureTruckStatus(sofar: Omit<GateTruck, "statusCode">, venueId: string): GateTruck {
    let status: VenueOverviewTruckStatusCode = "unknown";
    if (sofar.lastTripleg) {
        const tripleg = sofar.lastTripleg;
        if (tripleg.origin?.id === venueId && tripleg.departed) {
            status = "departed";
        } else if (tripleg.destination.id === venueId) {
            if (!tripleg.arrived) {
                status = "inbound";
            } else if (!tripleg.admitted) {
                status = "awaitingAdmission";
            } else {
                if (sofar.activeTransfersHere.length > 0) {
                    status = "working";
                } else if (sofar.possibleTransfersHere.length > 0) {
                    status = "waitingToWork";
                } else {
                    status = "idle";
                }
            }
        }
    }
    return {...sofar, statusCode: status};
}

function assembleGateTruck({venueId, truckStub, lastScene, lastTripleg, openTransfers, schedule, bundles}: {
    venueId: string,
    truckStub: TruckStub,
    lastScene: TruckScene | null,
    lastTripleg: Tripleg | null,
    openTransfers: Transfer[],
    schedule: ScheduledTransfer[],
    bundles: Bundle[]
}) {
    const bundlesById = objectFromEntries(bundles.map(bundle => ([bundle.id, bundle])));
    const activeTransfersHere: TruckBundleAction[] = [];
    const possibleTransfersHere: TruckBundleAction[] = [];

    for (const xfer of openTransfers) {
        const bundleId = xfer.bundle.id;
        if (bundleId) {
            const bundle = bundlesById[bundleId];
            if (bundle) {
                let nextfer: TruckBundleAction | undefined;
                if ((xfer.onloadVenue?.id === venueId && !!xfer.onloadStarted && !xfer.onloadEnded)) {
                    nextfer = {bundle, activeTransfer: xfer, direction: PickupOrDropoff.enum.PICKUP};
                } else if (xfer.offloadVenue?.id === venueId && !!xfer.offloadStarted && !xfer.offloadEnded) {
                    nextfer = {bundle, activeTransfer: xfer, direction: PickupOrDropoff.enum.DROPOFF};
                }

                if (nextfer) {
                    activeTransfersHere.push(nextfer);
                } else if (bundle.destination?.id === venueId) {
                    nextfer = {bundle, direction: PickupOrDropoff.enum.DROPOFF};
                    possibleTransfersHere.push(nextfer);
                }
            }
        }
    }

    for (const sxfer of schedule) {
        const bundle = bundlesById[sxfer.bundle.id];
        if (bundle) {
            possibleTransfersHere.push({
                direction: sxfer.direction,
                bundle,
                scheduled: sxfer,
            });
        }
    }

    const rv = figureTruckStatus({
        stub: truckStub,
        lastScene: lastScene ?? null,
        lastTripleg: lastTripleg ?? null,
        activeTransfersHere,
        possibleTransfersHere,
    }, venueId);
    return rv;
}

function ensureGateTruck({tqc, mama, truckStub, venueId}: {
    tqc: QueryClient,
    mama: KingBasura,
    truckStub: TruckStub,
    venueId: string,
}): Promise<GateTruck> {
    const fetchArgs = {tqc, mama, args: {truckId: truckStub.id, venueId}};

    return Promise.all([
        ensureLastSceneForTruck(fetchArgs),
        ensureLastTriplegForTruck(fetchArgs).then(rpc => rpc.tripleg),
        ensureFullOpenTransfersForTruck(fetchArgs)
            .then(rpcs => rpcs.map(rpc => rpc.transfer)),
        ensureFullScheduledTransfersAwaitingTruck(fetchArgs)
            .then(rpcs => rpcs.map(rpc => rpc.scheduledTransfer)),
    ]).then(([lastScene, lastTripleg, openTransfers, schedule]) => {
        const bundleStubs = cleanse(openTransfers.map(xfer => xfer.bundle));
        return Promise.all(bundleStubs.map(stub =>
            ensureBundleById({tqc, mama, args: {bundleId: stub.id}})
                .then(rpc => rpc.bundle)))
            .then(bundles => {
                return {lastScene, lastTripleg, openTransfers, schedule, bundles: cleanse(bundles)};
            });
    }).then(({lastScene, lastTripleg, openTransfers, schedule, bundles}) => {
        const rv = assembleGateTruck({
            venueId,
            truckStub: truckStub,
            lastScene: lastScene ?? null,
            lastTripleg: lastTripleg ?? null,
            openTransfers,
            schedule: cleanse(schedule),
            bundles,
        });
        return rv;
    });
}

const gateTruckVerb = "GateTruck";

function gateTruckTqk(args?: { truckId: string, venueId: string }) {
    return args ? [gateTruckVerb, args] as const : [gateTruckVerb] as const;
}

function gateTruckTqo(args?: {
    tqc: QueryClient,
    mama: KingBasura,
    truckStub: TruckStub,
    venueId: string
}) {
    return queryOptions({
        // eslint-disable-next-line @tanstack/query/exhaustive-deps
        queryKey: gateTruckTqk(args ? {truckId: args.truckStub.id, venueId: args.venueId} : undefined),
        queryFn: args ? () => ensureGateTruck(args) : skipToken,
    });
}

function GateTruckRelay(args: { truckStub: TruckStub, venueId: string }) {
    const tqc = useQueryClient();
    const mama = useMothership();
    const venueId = args.venueId;
    const truckArg = {truckId: args.truckStub.id};
    const lastSceneTqrv = useLastSceneForTruck(truckArg);
    const lastTriplegTqrv = useLastTriplegForTruck(truckArg);
    const openTransfersTqrv = useFullOpenTransfersForTruck(truckArg);
    const scheduledTransfersTqrv = useFullScheduledTransfersAwaitingTruck({venueId, truckId: args.truckStub.id});
    const bundleStubs = openTransfersTqrv.data
        ? cleanse(openTransfersTqrv.data.map(xfer => xfer?.bundle))
        : NADA;
    const bundleTqos = bundleStubs
        .map(stub => watchBundleByIdTqo(mama, {bundleId: stub.id}));
    const bundleTqrv = useQueries({
        queries: bundleTqos,
        combine: openTransfersTqrv.data ? mergeUseQueriesWithInfill : undefined,
    });

    useEffect(() => {
        if (lastTriplegTqrv.isSuccess && lastSceneTqrv.isSuccess
            && openTransfersTqrv.isSuccess && scheduledTransfersTqrv.isSuccess
            && bundleTqrv.isSuccess) {

            const lastScene = lastSceneTqrv.data ?? null;
            const lastTripleg = lastTriplegTqrv.data ?? null;
            const openTransfers = cleanse(openTransfersTqrv.data);
            const schedule = cleanse(scheduledTransfersTqrv.data);
            const bundles = cleanse(bundleTqrv.data);

            const cacheEntry = assembleGateTruck({
                venueId,
                truckStub: args.truckStub,
                lastScene,
                lastTripleg,
                openTransfers,
                schedule,
                bundles,
            });

            tqc.setQueryData(gateTruckTqk({venueId, truckId: args.truckStub.id}), cacheEntry);
        }
    }, [args.truckStub, bundleTqrv.data, bundleTqrv.isSuccess,
        lastSceneTqrv.data, lastSceneTqrv.isSuccess, lastTriplegTqrv.data,
        lastTriplegTqrv.isSuccess, openTransfersTqrv.data, openTransfersTqrv.isSuccess,
        scheduledTransfersTqrv.data, scheduledTransfersTqrv.isSuccess, tqc, venueId]);

    return null;
}

export function GateRelay({venueId}: { venueId: string }) {
    const stubsTqrv = useAdmitterTruckStubs({venueId});

    return <>
        {(stubsTqrv.data
            ? stubsTqrv.data.map(stub => <Fragment key={`venue-${venueId}-truck-${stub.id}`}>
                <TruckTimelineRelay truckId={stub.id}/>
                <GateTruckRelay truckStub={stub} venueId={venueId}/>
            </Fragment>)
            : null)}
    </>;
}

export function useGateTruck(args?: {
    venueId: string,
    truckStub: TruckStub
}): InfallibleUseQueryResult<GateTruck, Error> {
    const tqc = useQueryClient();
    const mama = useMothership();
    return useRefreshableInfallibleQuery(gateTruckTqo(args ? {tqc, mama, ...args} : undefined));
}

export function useGateTrucks({venueId}: { venueId: string }): InfallibleUseResult<GateTruck[]> {
    const tqc = useQueryClient();
    const mama = useMothership();
    const stubsTqrv = useAdmitterTruckStubs({venueId});
    const xtqrv = useQueries(stubsTqrv.data
        ? {
            queries: stubsTqrv.data.map(truckStub =>
                gateTruckTqo({tqc, mama, truckStub, venueId})),
            combine: mergeUseQueriesWithInfill,
        } : {queries: NADA});

    if (stubsTqrv.isPending || xtqrv.isPending) {
        return pendingUseResult;
    }

    const vxts = cleanse(xtqrv.data);
    return successUseResult(vxts);
}

